import React from 'react';

import { NotesEntityFields } from 'common/graphql/__generated__/NotesEntityFields';
import { NotesSectionProps } from 'common/components/NotesSection';
import { GenericNotesSection } from 'common/components/ActionMenu/Notes';

import {
  NoteDocumentPoolCreate,
  NoteDocumentPoolCreateVariables,
} from './__generated__/NoteDocumentPoolCreate';

import NOTE_DOCUMENT_POOL_CREATE from './NoteDocumentPoolCreate.graphql';

type NotesDocumentPoolProps = Pick<NotesSectionProps, 'listRefreshRequest'> & {
  documentPoolId: string;
  data: NotesEntityFields[];
  loading?: boolean;
};

export const NotesDocumentPool: React.FC<NotesDocumentPoolProps> = ({
  documentPoolId,
  listRefreshRequest,
  data,
  loading,
}) => {
  return (
    <GenericNotesSection<
      any,
      NoteDocumentPoolCreate,
      NoteDocumentPoolCreateVariables
    >
      entityId={documentPoolId}
      data={data}
      loading={loading}
      mutationDocument={NOTE_DOCUMENT_POOL_CREATE}
      listRefreshRequest={listRefreshRequest}
    />
  );
};
